import { paths } from '../../../constants/paths';

export const getItems = (requestsCount = {}) => {
  const {
    all,
    active,
    immediate,
    expired,
    retry,
    chargeable,
    averageLifetime,
  } = requestsCount;

  return [
    {
      key: 'all',
      title: 'Всего заявок',
      count: all,
      link: paths.all,
    },
    {
      key: 'active',
      title: 'Новые',
      count: active,
      link: paths.active,
    },
    {
      key: 'immediate',
      title: 'Аварийные',
      count: immediate,
      link: paths.immediate,
    },
    {
      key: 'expired',
      title: 'Просроченные',
      count: expired,
      link: paths.expired,
    },
    {
      key: 'retry',
      title: 'Открытые повторно',
      count: retry,
      link: paths.retry,
    },
    {
      key: 'chargeable',
      title: 'Платные',
      count: chargeable,
      link: paths.chargeable,
    },
    {
      key: 'lifetime',
      title: `Время жизни заявки (дн.)`,
      count: averageLifetime,
      link: paths.lifetime,
      defaultSearchParam: ``,
      description: 'Нет выполненных заявок',
    },
  ];
};
